// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"menu_menuWrapper__3ksHl"};